var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePasswordHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30523",
    "data-name": "Path 30523",
    d: "M18201.383,21h-10.762a4.624,4.624,0,0,1-4.619-4.619V5.62A4.624,4.624,0,0,1,18190.621,1h10.762A4.624,4.624,0,0,1,18206,5.62V16.382A4.624,4.624,0,0,1,18201.383,21Zm-6.02-8.857v0l-.459,2.477h2.232l-.48-2.48,1.906,1.68,1.148-2.025-2.344-.8,2.344-.82-1.074-1.947-1.98,1.66.5-2.516h-2.271l.494,2.516-1.979-1.66-1.086,1.963,2.324.766-2.348.82,1.184,2.057,1.889-1.695Z",
    transform: "translate(-18186.002 -1.001)",
    fill: "#f2824c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordHover);
export default __webpack_public_path__ + "static/media/ChangePasswordHover.6fc9caedb10402f6e2aee2781481d62c.svg";
export { ForwardRef as ReactComponent };